import { useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';

const PRIMARY_ITEM = {
  label: 'Investor Tools',
  icon: 'pi-calculator',
  path: '/',
  match: (pathname) => pathname === '/' || pathname.startsWith('/tools'),
};

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="nb">
      <div className="nb-inner">
        <button
          type="button"
          className="nb-logo"
          onClick={() => navigate('/')}
          aria-label="Go to investor tools"
        >
          <img src="/gravvisoft-logo-header-transparent.png" alt="GravviSoft" className="nb-logo-img" />
        </button>

        <div className="nb-links">
          <button
            type="button"
            className={`nb-link${PRIMARY_ITEM.match(location.pathname) ? ' nb-link--active' : ''}`}
            onClick={() => navigate(PRIMARY_ITEM.path)}
          >
            <i className={`pi ${PRIMARY_ITEM.icon}`}></i>
            <span>{PRIMARY_ITEM.label}</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
